import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/videos/sailing-video-analytics.mp4")